var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FolderOpenOutlined, StopOutlined } from '@ant-design/icons';
import { GeofenceType } from '@tenderd/schema';
import { GroupPermission } from '@tenderd/track-web-utils';
import { Tag } from 'antd';
import React from 'react';
import { useGroupService } from '../../../../providers/GroupServiceProvider';
import { useGroupPermissions } from '../../../../providers/useGroupPermissions';
import { GroupGeofenceAction, useGroupGeofencePageContext, } from '../../GroupGeofencePage.context';
import EditIcon from './../../icons/Edit-Icon';
import './GeofenceListItem.style.css';
var GeofenceListItem = function (_a) {
    var selected = _a.selected, props = __rest(_a, ["selected"]);
    var context = useGroupGeofencePageContext();
    var group = useGroupService().group;
    var permissions = useGroupPermissions();
    var canEditGeofence = permissions === GroupPermission.Admin &&
        group.id === props.group_ref.id;
    return (React.createElement("div", { className: "geofence-list-item ".concat(selected ? 'selected' : ''), onClick: function () {
            context.setMode(undefined);
            context.setSelectedGeofence(props);
            context.setGeofenceAction(GroupGeofenceAction.UpdateGeofence);
        } },
        props.group_ref && (React.createElement("div", { className: "group-name" },
            React.createElement(FolderOpenOutlined, null),
            React.createElement("span", null, props.group_ref.label))),
        React.createElement("div", { className: "geofence-name" },
            React.createElement("h3", null, props.name),
            props.type === GeofenceType.Restricted && (React.createElement("div", { className: "restricted-zone" },
                React.createElement(StopOutlined, { color: "#E65F38" }),
                React.createElement("span", null, "Restricted Zone")))),
        props.allowedEquipmentTypes &&
            props.allowedEquipmentTypes.length ? (React.createElement("div", { className: "geofences-tags" }, props.allowedEquipmentTypes.map(function (equipmentType) { return (React.createElement(Tag, null, equipmentType)); }))) : (React.createElement(React.Fragment, null)),
        canEditGeofence && (React.createElement("div", { className: "edit-action", onClick: function () {
                context.setPostGeofenceModal(true);
                context.setGeofenceAction(GroupGeofenceAction.UpdateGeofence);
            } },
            React.createElement(EditIcon, null),
            " Edit"))));
};
export default GeofenceListItem;
